import { Fragment } from 'react';

const CategoryDropdown = ({ label, categories, activeCategory, setCategory }) => {


  return (
    <Fragment>
      {label && <label htmlFor='select-box'>{label}</label>}
      <select
        id='select-box'
        value={activeCategory}
        onChange={(event) => setCategory(event.currentTarget.value)}
      >
        {categories?.sort().map((optionValue) => (
          <option key={optionValue} value={optionValue}>
            {optionValue}
          </option>
        ))}
      </select>
    </Fragment>
  );
};

export default CategoryDropdown;
